/**
 * 聚水潭 ERP 第一章截图场景。
 *
 * 图片、步骤提示、热区和表单校验统一在这里维护；页面组件只负责挂载 StepPlayer。
 * 将截图放入 `src/assets/images/jushuitan/scenes/` 后，仅替换下面
 * SCENE_IMAGES 中的三个路径即可，不需要改动热区流程代码。
 *
 * 推荐图片：
 * - login：完整登录页截图
 * - home：登录成功后首页截图
 * - done：点击“订单”后的成功页面截图（首版也可与 home 相同）
 */

import { getGoodsList } from './jstErpGoodsData'
import { br, red } from './jstTip'

function r(path) {
  return require('@/assets/images/jushuitan/' + path)
}

const ALL_GOODS = getGoodsList()
const TARGET_GOODS = ALL_GOODS[0]
const TARGET_GOODS_CODE = TARGET_GOODS.goodsCode
const AFTERSALE_ISSUE_TYPES = [
  '尺码拍错/不喜欢/效果差',
  '商品质量问题',
  '重复购买',
  '大小尺寸与商品描述不符',
  '不想买了',
  '买错了',
  '其他',
  '服务承诺或态度'
]

const SCENE_IMAGES = {
  login: r('jst_login.png'),
  home: r('1-0.png'),
  home_click: r('1-1.png'),
  fast: r('1-2.png'),
  noinfo: r('1-3.png'),
  noinfo_goods: r('1-4.png'),
  noinfo_done: r('1-5.png'),
}

export function getJstErpScenario() {
  return {
    initialStepId: 'login',
    initialForm: {
      loginAccount: '', loginPassword: '', loginAgreement: false, goodsCode: '', goodsNum: 0, goodsCodes: '',
      returnExpress: '', returnWaybill: '', returnWarehouse: '', aftersaleIssueType: ''
    },
    steps: [
      {
        id: 'login',
        image: SCENE_IMAGES.login,
        aspectRatio: 2,
        tip: '登录聚水潭' + br() + '账号：' + red('taojinyun-jst') + br() + '密码：' + red('Tj123456'),
        fields: [
          { id: 'login-account', model: 'loginAccount', type: 'text', placeholder: '邮箱地址/手机号', bgColor: '#fff', fontSize: 12, x: 0.614, y: 0.369, w: 0.179, h: 0.034, autoFocus: true, hideCaret: false },
          { id: 'login-password', model: 'loginPassword', type: 'password', placeholder: '请输入密码', bgColor: '#fff', fontSize: 12, x: 0.614, y: 0.462, w: 0.179, h: 0.034 }
        ],
        labels: ({ form }) => form.loginAgreement ? [{
          id: 'login-agreement-check',
          text: '✓',
          color: '#1677ff',
          fontSize: 15,
          fontWeight: 'bold',
          x: 0.61,
          y: 0.531,
          w: 0.01,
          h: 0.022
        }] : [],
        hotspots: [
          {
            id: 'login-agreement',
            x: 0.608,
            y: 0.53,
            w: 0.018,
            h: 0.024,
            highlight: 'primary',
            action: ({ form }) => ({ setForm: { loginAgreement: !form.loginAgreement } })
          },
          {
            id: 'login-button',
            x: 0.61,
            y: 0.567,
            w: 0.193,
            h: 0.04,
            highlight: 'primary',
            guard: ({ form }) => {
              if (form.loginAccount !== 'taojinyun-jst') return { ok: false, msg: '请输入正确的登录账号' }
              if (form.loginPassword !== 'Tj123456') return { ok: false, msg: '请输入正确的登录密码' }
              if (!form.loginAgreement) return { ok: false, msg: '请先勾选阅读并同意协议' }
              return { ok: true }
            },
            next: 'home'
          }
        ]
      },
      {
        id: 'home',
        image: SCENE_IMAGES.home,
        aspectRatio: 2,
        tip: '进入' + red('售后极速版'),
        hotspots: [
          {
            id: 'home-menu',
            x: 0,
            y: 0.06,
            w: 0.03,
            h: 0.06,
            highlight: 'primary',
            next: 'home_click'
          }
        ]
      },
      {
        id: 'home_click',
        image: SCENE_IMAGES.home_click,
        aspectRatio: 2,
        tip: '进入' + red('售后极速版'),
        hotspots: [
          { 
            id: 'topOrder', 
            x: 0.294, 
            y: 0.122, 
            w: 0.084, 
            h: 0.03, 
            highlight: 'primary', 
            next: 'fast' 
          },
          {
            id: 'common-fast-aftersale',
            x: 0.04,
            y: 0.524,
            w: 0.1,
            h: 0.032,
            highlight: 'primary',
            next: 'fast'
          }
        ]
      },
      {
        id: 'fast',
        image: SCENE_IMAGES.fast,
        aspectRatio: 2,
        tip: '登记无信息件' + br() + '商品' + red('TEST-GD-0001退回') + br() + '买家退回快递公司：' + red('圆通') + br() + '买家退回快递单号：' + red('YT8888888888') + br() + '退回仓库：' + red('淘金仓库') + br() + '售后问题类型：' + red('尺码拍错/不喜欢/效果差') ,
        hotspots: [
          { 
            id: 'noinfo-btn', 
            x: 0.89, 
            y: 0.52, 
            w: 0.084, 
            h: 0.03, 
            highlight: 'primary', 
            next: 'noinfo-goods-add' 
          },
        ]
      },
      {
        id: 'noinfo-goods-add',
        image: SCENE_IMAGES.noinfo,
        aspectRatio: 2,
        tip: '登记无信息件' + br() + '商品' + red('TEST-GD-0001退回') + br() + '买家退回快递公司：' + red('圆通') + br() + '买家退回快递单号：' + red('YT8888888888') + br() + '退回仓库：' + red('淘金仓库') + br() + '售后问题类型：' + red('尺码拍错/不喜欢/效果差') ,
        hotspots: [
          { 
            id: 'noinfo', 
            x: 0.14, 
            y: 0.162, 
            w: 0.084, 
            h: 0.03, 
            highlight: 'primary', 
            next: 'noinfo-goods' 
          },
        ]
      },
      {
        id: 'noinfo-goods',
        image: SCENE_IMAGES.noinfo_goods,
        aspectRatio: 2,
        tip: '登记无信息件' + br() + '商品' + red('TEST-GD-0001退回') + br() + '买家退回快递公司：' + red('圆通') + br() + '买家退回快递单号：' + red('YT8888888888') + br() + '退回仓库：' + red('淘金仓库') + br() + '售后问题类型：' + red('尺码拍错/不喜欢/效果差') ,
        fields: [
          { id: 'goods-code', model: 'goodsCode', type: 'text', bgColor: '#FFFFFF', fontSize: 10, placeholder: '商品编码', x: 0.275, y: 0.22, w: 0.08, h: 0.02 },
          { id: 'goods-num', model: 'goodsNum', type: 'label', fontSize: 12, color: '#5045a8', x: 0.265, y: 0.305, h: 0.02 },
          { id: 'goods-codes', model: 'goodsCodes', type: 'label', fontSize: 12, color: '#5045a8', x: 0.285, y: 0.305, w: 0.53, h: 0.02 }
        ],
        tables: ({ ui, form }) => {
          const keyword = (form.goodsCode || '').trim().toUpperCase()
          const filtered = ui.goodsSearched && keyword
            ? ALL_GOODS.filter(g => g.goodsCode.toUpperCase().indexOf(keyword) !== -1 || g.goodsName.toUpperCase().indexOf(keyword) !== -1)
            : ALL_GOODS
          const selectedRows = Array.isArray(ui['goods-tableSelectedRows']) ? ui['goods-tableSelectedRows'] : []
          const selectedKeys = Array.isArray(ui['goods-tableSelectedKeys']) ? ui['goods-tableSelectedKeys'] : []
          const selectedRowMap = selectedRows.reduce((map, row) => {
            map[row.id] = row
            return map
          }, {})
          return [{
            id: 'goods-table',
            x: 0.215,
            y: 0.34,
            w: 0.605,
            h: 0.36,
            rows: filtered.map(row => selectedRowMap[row.id] ? { ...row, quantity: selectedRowMap[row.id].quantity } : row),
            selectedKeys,
            columns: [
              { key: 'image', type: 'image', title: '图片', width: 60 },
              { key: 'goodsName', title: '商品名称', width: 180 },
              { key: 'goodsShortName', title: '商品简称', width: 140 },
              { key: 'quantity', type: 'input', title: '数量', width: 70, align: 'right' },
              { key: 'price', title: '单价', width: 70, align: 'right' },
              { key: 'goodsCode', title: '商品编码', width: 170 },
              { key: 'styleCode', title: '款式编码', width: 130 },
              { key: 'spec', title: '颜色及规格', width: 160 },
            ],
            selectable: true,
            rowKey: 'id',
            pageSize: 10,
            onSelectionChange: ({ selectedKeys, selectedRows, setForm }) => {
              setForm({
                goodsNum: selectedKeys.length,
                goodsCodes: selectedRows.map(r => r.goodsCode).join(',')
              })
            }
          }]
        },
        hotspots: [
          {
            id: 'goods-search',
            x: 0.744,
            y: 0.252,
            w: 0.032,
            h: 0.03,
            highlight: 'primary',
            guard: ({ form }) => String(form.goodsCode || '').trim().toUpperCase() === TARGET_GOODS_CODE.toUpperCase()
              ? { ok: true }
              : { ok: false, msg: '请输入正确的商品编码 ' + TARGET_GOODS_CODE },
            set: { goodsSearched: true }
          },
          {
            id: 'goods-confirm',
            x: 0.788,
            y: 0.722,
            w: 0.033,
            h: 0.03,
            highlight: 'primary',
            guard: ({ ui }) => ((ui['goods-tableSelectedKeys'] || []).includes(TARGET_GOODS.id) && ui.goodsSearched
              ? { ok: true }
              : { ok: false, msg: '请搜索并选中商品 ' + TARGET_GOODS_CODE }),
            next: 'done'
          },
        ]
      },
      {
        id: 'done',
        image: SCENE_IMAGES.noinfo_done,
        aspectRatio: 2,
        tip: '登记无信息件' + br() + '商品' + red('TEST-GD-0001退回') + br() + '买家退回快递公司：' + red('圆通') + br() + '买家退回快递单号：' + red('YT8888888888') + br() + '退回仓库：' + red('淘金仓库') + br() + '售后问题类型：' + red('尺码拍错/不喜欢/效果差') ,
        fields: [
          { id: 'return-express', model: 'returnExpress', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.207, y: 0.549, w: 0.21, h: 0.028 },
          { id: 'return-waybill', model: 'returnWaybill', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.488, y: 0.549, w: 0.21, h: 0.028 },
          { id: 'return-warehouse', model: 'returnWarehouse', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '请选择', options: ['淘金仓库'], x: 0.739, y: 0.549, w: 0.24, h: 0.028 },
          { id: 'aftersale-issue-type', model: 'aftersaleIssueType', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '请选择', options: AFTERSALE_ISSUE_TYPES, x: 0.207, y: 0.587, w: 0.21, h: 0.028 }
        ],
        tables: ({ ui }) => {
          const selectedRows = Array.isArray(ui['goods-tableSelectedRows']) ? ui['goods-tableSelectedRows'] : []
          const selectedKeys = selectedRows.map(r => r.id)
          return [{
            id: 'done-goods-table',
            x: 0.14,
            y: 0.2,
            w: 0.845,
            h: 0.32,
            rows: selectedRows,
            selectedKeys,
            columns: [
              { key: 'image', type: 'image', title: '图片', width: 60 },
              { key: 'goodsName', title: '商品名称', width: 180 },
              { key: 'goodsShortName', title: '商品简称', width: 140 },
              { key: 'quantity', title: '数量', width: 70, align: 'right' },
              { key: 'price', title: '单价', width: 70, align: 'right' },
              { key: 'goodsCode', title: '商品编码', width: 170 },
              { key: 'styleCode', title: '款式编码', width: 130 },
              { key: 'spec', title: '颜色及规格', width: 160 }
            ],
            selectable: true,
            rowKey: 'id'
          }]
        },
        hotspots: [{
          id: 'save-aftersale',
          x: 0.958,
          y: 0.959,
          w: 0.033,
          h: 0.03,
          highlight: 'primary',
          guard: ({ form }) => {
            if (!String(form.returnExpress || '').trim()) return { ok: false, msg: '请填写买家退回快递公司' }
            if (!String(form.returnWaybill || '').trim()) return { ok: false, msg: '请填写买家退回快递单号' }
            if (!String(form.returnWarehouse || '').trim()) return { ok: false, msg: '请选择退货仓库' }
            if (!String(form.aftersaleIssueType || '').trim()) return { ok: false, msg: '请选择售后问题类型' }
            return { ok: true }
          },
          action: ({ ui, form }) => {
            const selectedRows = Array.isArray(ui['goods-tableSelectedRows']) ? ui['goods-tableSelectedRows'] : []
            const selectedGoods = selectedRows[0] || TARGET_GOODS
            return {
              set: {
                createdAftersale: {
                  aftersaleNo: 'SH202608070001',
                  goodsName: selectedGoods.goodsName,
                  goodsCode: selectedGoods.goodsCode,
                  returnExpress: form.returnExpress,
                  returnWaybill: form.returnWaybill,
                  returnWarehouse: form.returnWarehouse,
                  issueType: form.aftersaleIssueType,
                  status: '待确认'
                }
              },
              next: 'fast-created'
            }
          }
        }]
      },
      {
        id: 'fast-created',
        image: SCENE_IMAGES.fast,
        aspectRatio: 2,
        tip: '登记无信息件' + br() + '商品' + red('TEST-GD-0001退回') + br() + '买家退回快递公司：' + red('圆通') + br() + '买家退回快递单号：' + red('YT8888888888') + br() + '退回仓库：' + red('淘金仓库') + br() + '售后问题类型：' + red('尺码拍错/不喜欢/效果差') ,
        tables: ({ ui }) => ui.createdAftersale ? [{
          id: 'created-aftersale-table',
          x: 0.04,
          y: 0.62,
          w: 0.94,
          h: 0.25,
          rows: [ui.createdAftersale],
          columns: [
            { key: 'aftersaleNo', title: '售后单号', width: 150 },
            { key: 'status', title: '售后单状态', width: 110 },
            { key: 'goodsCode', title: '商品编码', width: 150 },
            { key: 'goodsName', title: '商品名称', width: 220 },
            { key: 'returnExpress', title: '退回快递公司', width: 130 },
            { key: 'returnWaybill', title: '退回快递单号', width: 170 },
            { key: 'returnWarehouse', title: '退货仓库', width: 130 },
            { key: 'issueType', title: '售后问题类型', width: 180 }
          ],
          rowKey: 'aftersaleNo',
          selectable: false
        }] : [],
        afterEnter: { delay: 2000, finish: true }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/page/simulate/jushuitan/jstErpScenarios.js